module.exports = __webpack_public_path__ + "static/media/mobile-logo.1dd6dead.png";